import React, { useState } from "react";
import Dropdown from "../Dropdown/Dropdown";
import Header from "../Header/Header";
import Pb from "../../Assets/pb.png"
import FeelingProud from "./FeelingProud";
import { useEffect } from "react";
import {
  HeroContainer,
  HeroWrapper,
  HeroLeft,
  HeroRight,
  Image,
  ScrollDown,
  ScrollLink,
} from "./HeroElements";
function Hero() {
  const [isOpen, setIsOpen] = useState(false);
  const [theme, setTheme] = useState({
    accentBright: "#FC1056",
    accentColor: "#E3405F",
    avatarMisc: "#212121",
    avatarShoes: "#2B2B2B",
    body: "#1D1D1D",
    dark: "#000000",
    imageClothes: "#000000",
    imageDark: "#292A2D",
    name: "light",
    projectCard: "#292A2D",
    secondaryText: "#8D8D8D",
    skinColor: "#F7B799",
    skinColor2: "#FCB696",
    text: "#FFFFFF",
  });
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  var TxtType = function (el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = "";
    this.tick();
    this.isDeleting = false;
  };

  TxtType.prototype.tick = function () {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) {
      delta /= 2;
    }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === "") {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function () {
      that.tick();
    }, delta);
  };

  function Run() {
    var elements = document.getElementsByClassName("typewrite");
    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute("data-type");
      var period = elements[i].getAttribute("data-period");
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
    document.body.appendChild(css);
  }
  useEffect(() => {
    // Update the document title using the browser API
    Run();
    console.log("s");
  }, []);

  return (
    <main>
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Header toggle={toggle} />
      <HeroContainer>
        <HeroWrapper>
          <HeroLeft>
            <h1
            style={{fontSize:"40px"}}
              className="typewrite"
              data-period="2000"
              data-type='[ "Hello", "I am Prajal "  ]'
            >
              {" "}
            </h1>
            {/* // <h1>Hi, I'm Prajal </h1> */}
            <h5>Full Stack Developer</h5>
            <p>
              I design and code beautifully simple things, and I love what I do.
            </p>
          </HeroLeft>
          <HeroRight style={{}}>
            <Image
            ///https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/man-svgrepo-com.svg
            //"https://avatars.githubusercontent.com/u/86410181?v=4"
              src={Pb}
              alt="man-svgrepo"
            />
            {/* <FeelingProud theme={theme}/> */}
          </HeroRight>
        </HeroWrapper>
        <ScrollDown to="projects">
          <ScrollLink>
            Scroll down
            <img
              src="https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/scroll-down.svg"
              alt="scroll-down"
            />
          </ScrollLink>
        </ScrollDown>
      </HeroContainer>
    </main>
  );
}

export default Hero;
